var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._b({staticClass:"form-control text-right",attrs:{"type":"number","step":0.01},domProps:{"value":_vm.displayValue},on:{"input":function($event){return _vm.updateValue($event.target.value)}}},'input',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }